const AUTH_ENDPOINT = '/broadcasting/auth'
const knownErrorCodes = new Set([
  'ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT', 'ERR_CANCELED',
  'ERR_BAD_REQUEST', 'ERR_BAD_RESPONSE',
  'ERR_BAD_OPTION', 'ERR_BAD_OPTION_VALUE',
])

const httpStatus = value => Number.isInteger(value) && value >= 100 && value <= 599 ? value : null

const describeFailure = error => {
  const status = httpStatus(error?.response?.status)
  const code = knownErrorCodes.has(error?.code) ? error.code : 'CLIENT_ERROR'
  const kind = status !== null ? 'http_error'
    : ['ERR_BAD_OPTION', 'ERR_BAD_OPTION_VALUE'].includes(code) ? 'client_error'
    : (error?.isAxiosError || ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(code))
      ? 'network_error' : 'client_error'

  return { kind, status, code }
}

export default function createBroadcastAuthorizer(axiosClient, logger = console) {
  return channel => ({
    authorize: (socketId, callback) => {
      const fail = details => {
        if (details.code !== 'ERR_CANCELED') logger.error('Broadcast auth failed:', details)
        const error = new Error(details.kind === 'network_error'
          ? 'Broadcast authorization failed without an HTTP response.'
          : 'Broadcast authorization failed.')
        error.status = details.status
        error.code = details.code
        callback(error, null)
      }

      // A callback exception must not trigger a second authorization callback.
      return Promise.resolve()
        .then(() => axiosClient.post(AUTH_ENDPOINT, {
          socket_id: socketId,
          channel_name: channel.name,
        }, { timeout: 10000 }))
        .then(response => {
          if (typeof response?.data?.auth !== 'string' || response.data.auth.trim() === '') {
            fail({ kind: 'invalid_response', status: httpStatus(response?.status), code: 'INVALID_AUTH_RESPONSE' })
            return
          }
          callback(false, response.data)
        }, error => fail(describeFailure(error)))
        .catch(() => {
          logger.error('Broadcast callback failed:', { kind: 'callback_error' })
        })
    },
  })
}
